(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7380],{

/***/ 54238:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/popover",
      function () {
        return __webpack_require__(34606);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ popover; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/lib/helpers.tsx
var helpers = __webpack_require__(62670);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/lib/ToastHighLighter.tsx + 1 modules
var ToastHighLighter = __webpack_require__(19203);
;// CONCATENATED MODULE: ./src/components/codeHighlights/PopverCode.tsx


var PopoverCode = function() {
    var language = "html";
    var codeString = '\n// Popover\n<button\n  type="button"\n  class="btn btn-primary"\n  data-bs-toggle="popover"\n  data-bs-placement="right | left | top | bottom"\n  data-bs-trigger="hover focus"\n  title="Popover title"\n  data-bs-content="Content goes here ..."\n>\n  Popover content ...\n</button>  \n';
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastHighLighter/* default */.Z, {
            name: "popover",
            codeString: codeString,
            language: language,
            show: true
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/Popover.tsx





var PopOver = function(param) {
    var styles = param.styles, _placement = param.placement, placement = _placement === void 0 ? "left" : _placement;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            var popoverNode = document.querySelector(".popover.show");
            if (popoverNode) {
                popoverNode.classList.remove("show");
            }
        };
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 col-sm-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: styles,
                            "data-bs-toggle": "popover",
                            "data-bs-placement": "bottom",
                            "data-bs-trigger": "hover focus",
                            title: "Popover title",
                            "data-bs-content": "And here's some amazing content. It's very engaging. Right?",
                            children: "Hover to toggle popover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                id: "popover",
                                type: "module",
                                children: "\n              var popoverTriggerList = [].slice.call(\n                document.querySelectorAll('[data-bs-toggle=\"popover\"]')\n              );\n            \n              var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {\n              return new bootstrap.Popover(popoverTriggerEl);\n              });\n            "
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 col-sm-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: styles,
                            "data-bs-toggle": "popover2",
                            "data-bs-placement": "top",
                            "data-bs-trigger": "click",
                            title: "Popover title",
                            "data-bs-content": "And here's some amazing content. It's very engaging. Top?",
                            children: "Click to toggle popover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                id: "popover2",
                                type: "module",
                                children: "\n          var popoverTriggerList = [].slice.call(\n            document.querySelectorAll('[data-bs-toggle=\"popover2\"]')\n            );\n            \n            var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {\n              return new bootstrap.Popover(popoverTriggerEl);\n            });\n            "
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 mt-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverCode, {})
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/components/popover.tsx




var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Popover - FHNW Styleguide",
                description: "Komponente Popover",
                canonical: "".concat("https://web.fhnw.ch/fhnw-styleguide-v5").concat((0,helpers/* GetPathName */.R)())
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Popover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver, {
                styles: "btn btn-lg btn-primary w-100"
            })
        ]
    });
};
/* harmony default export */ var popover = (Page);


/***/ }),

/***/ 19203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_ToastHighLighter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/prism.js + 15 modules
var prism = __webpack_require__(5227);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/prism/index.js
var styles_prism = __webpack_require__(84283);
;// CONCATENATED MODULE: ./src/lib/HighLighter.tsx



var CodeHighLight = function(param) {
    var codeString = param.codeString, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(prism/* default */.Z, {
        language: language,
        wrapLines: true,
        showLineNumbers: true,
        style: styles_prism/* dracula */.cL,
        children: codeString
    });
};
/* harmony default export */ var HighLighter = (CodeHighLight);

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/lib/ToastHighLighter.tsx




var ToastHighLighter = function(param) {
    var name = param.name, codeString = param.codeString, language = param.language, show = param.show, _disableCopy = param.disableCopy, disableCopy = _disableCopy === void 0 ? false : _disableCopy;
    var ref = (0,react.useState)(false), state = ref[0], setState = ref[1];
    var handleClick = function() {
        setState(true);
        setTimeout(function() {
            setState(false);
        }, 5000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn btn-light btn-sm text-uppercase",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#".concat(name),
                "aria-expanded": "".concat(show ? "true" : "false"),
                "aria-controls": name,
                children: language
            }),
            disableCopy === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: codeString,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn btn-info btn-sm",
                    onClick: handleClick,
                    children: "Code kopieren"
                })
            }) : false,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapse ".concat(show ? "show" : false),
                id: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card card-body highlighter",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighLighter, {
                        codeString: codeString,
                        language: language
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "position-fixed top-0 end-0 p-3",
                style: {
                    zIndex: 1100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "liveToast",
                    className: "toast ".concat(state ? "show" : "hide"),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "toast-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "me-auto",
                                    children: "Code copied to clipboard"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn-close",
                                    "data-bs-dismiss": "toast",
                                    "aria-label": "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "toast-body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighLighter, {
                                codeString: codeString,
                                language: language
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var lib_ToastHighLighter = (ToastHighLighter);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,5063,9774,2888,179], function() { return __webpack_exec__(54238); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);